module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "int01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }), _c('h2', {
    staticClass: "chapterTitle1"
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/9780061745287_contents#int_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Introduction")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Not long ago, while on a flight from my home in New York City to New Orleans, the woman seated to my right asked me a couple of seemingly innocent questions: “Are you traveling on business?” and “What kind of work do you do?” I’d learned from past experience that answering innocent questions can easily lead to uncomfortably long silences, which are especially uncomfortable when you’re seated elbow-to-elbow in a steel tube at forty thousand feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I remember one fellow, an Israeli, who started a conversation with me just as our plane left the ground on the way from New York to Los Angeles. A few questions later, after he learned that I wrote books about gay people, the conversation ended. My seatmate never said another word during the six-hour flight, and upon our landing in L.A. he was out of his seat before we reached the gate.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Like everyone else, I’m human, so I try to avoid uncomfortable situations. And I had an uneasy feeling on the New Orleans–bound flight that the woman asking the questions might not welcome the gay man seated next to her. I’d already overheard a piece of a conversation she’d had with a colleague across the aisle about an article in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("USA Today")]), _vm._v(" that had something to do with gay people. And from the tone of the conversation, I thought I had reason to be wary.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Her questions and answers followed a predictable progression: “Oh, you’re a writer. What do you write?” “I write books.” “What kinds of books?” “Nonfiction.” “What kinds of nonfiction?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I wasn’t trying to be coy, but I was hoping that my less than expansive answers would get me off the hook. My seatmate was undaunted, and sure enough, after I told her that most of my books were about gay people, there was silence. But not for long, because then Lillian started telling me about her youngest son, of whom she was very proud. He wasn’t like his other brothers, who were athletic, but instead loved to sing and dance and was always the star of his school plays. She pulled his school photo from her purse, showed it to me, and promptly burst into tears.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I think my son is gay,” Lillian said, “and I don’t know what to do.” She explained that she had never talked to anyone about her concerns besides her husband. Ten-year-old Andrew was already getting called names at elementary school, and she feared for his safety. She loved her son and wanted to do everything she could to make certain he’d grow up to be a well-adjusted gay kid. For a moment "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I")]), _vm._v(" was speechless, and then I had a few questions of my own. (For more about Andrew and his mom, have a look at chapter 5, “For Parents of Gay Children.”)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I’ve been answering questions about homosexuality for what feels like a very long time—beginning in 1976, to be exact. But it wasn’t until 1988, when my first book—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Male Couple’s Guide")]), _vm._v("—was published, that I realized just how little most people knew about homosexuality.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("My publisher sent me on a ten-day publicity trip across the United States, during which time I discovered that no one was interested in the substance of my book. All the questions that came my way were very basic: “How do you know you’re a ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("homosexual?” “How do parents react to a gay child?” “Why do gay people want to get married?”")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Still, it wasn’t until I discovered that my own friends had the same basic questions everyone else had that I realized there was a desperate need for a book that offered clear, concise answers about gay and lesbian people and the lives we lead.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Shortly after returning home from my cross-country trip, I had dinner with my good friends Duffie and Simeon. She’s a journalist, and he’s a lawyer. Recently married. Highly educated. New York sophisticates. I thought nothing of complaining to them about my experiences on the road: “You can’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("believe")]), _vm._v(" the stupid questions I have to answer.” Duffie asked, “What kinds of stupid questions?” I rattled off a long list, including the one question I was asked most often: “Is it a choice?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Duffie turned bright red, paused, and said, “Those don’t sound like stupid questions to me.” Simeon said: “It’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" a choice?” I almost fell off my chair. They were my friends! They had known me for years! They lived in Manhattan, for God’s sake! But they didn’t know. After thinking about it for a little while, I realized that Duffie and I, after our initial discussion when we met in graduate school, had never talked about the fact that I was gay. I had just assumed that Duffie and Simeon knew about gay people. But they didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The next week, I had dinner with friends of mine and theirs. Kate and Rick are a little older than Duffie and Simeon. Totally cool people. Kate’s a potter, and Rick is a brilliant economist. I assumed they’d be as shocked as I was at how little Duffie and Simeon knew. Well, you can easily imagine how the rest of the conversation played out. Kate and Rick were surprised by my surprise and suggested that I was mistaken in my assumptions. No kidding.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("After that night with Kate and Rick, I was determined to write a book that included all the questions I had ever been asked and then some. You’re holding in your hands the third edition of the original "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Is It a Choice?,")]), _vm._v(" which over the years has been translated into Spanish, Hebrew, Polish, Thai, and Japanese. So now the questions come to me via e-mail from as far away as Bangladesh, Jordan, and Nepal.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The questions and answers you’ll find in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Is It a Choice?")]), _vm._v(" come from many different sources. Most of the questions are my own; others were gathered from friends, family, people I’ve met through my travels; and still others have come from readers around the world. For the answers to the many questions I’ve included here, I talked to lots of people, including experts from a variety of fields. I’ve also drawn information from magazine and newspaper articles, as well as scores of books and Web sites. And I’ve read reports and studies, lots of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As you’ll see, my responses range from exceedingly brief to detailed and involved. You’ll find plenty of anecdotes, opinions, and conjecture, but some of the answers will leave you with even more questions, because some of the questions I’ve included don’t yet have definitive answers.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The answers I offer in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Is It a Choice?")]), _vm._v(" are mostly "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("my")]), _vm._v(" answers, which means they’re not the only possible answers to the questions I pose. Other gay and lesbian people would likely answer these questions differently, because gay men and women are a diverse population with different values and different ways of looking at our world.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Some of you may be disappointed to discover in the answers I offer that gay people aren’t nearly as exotic as we’re sometimes portrayed, especially by those individuals and organizations that would have you believe we are forever parading, ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("scantily clad in black leather or sequins, down the main streets of cities near and far.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("In fact, some gay and lesbian people "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" pretty exotic and dress up in very imaginative ways, but the same can be said of some heterosexual people. (Have you ever been to Mardi Gras or Carnival?) But in writing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Is It a Choice")]), _vm._v("? I’ve chosen to stick pretty close to the broad middle of lesbian and gay life. And I’ve also limited myself primarily to addressing questions about the “L” and “G” of the LGBT acronym often used to denote the lesbian, gay, bisexual, and transgender communities.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("You’ll meet all kinds of people in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Is It a Choice?")]), _vm._v(" Some give answers to questions; others provide stories that help support a point. When I’ve used quotes or anecdotes from experts and public people, such as gay and lesbian rights advocates, I’ve used complete names. When I quote private citizens or use their anecdotes—some of which are composites drawn from several people—I’ve used only first names and changed identifying details for reasons of privacy.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Not all the possible questions about homosexuality are included in this relatively brief volume, nor are all the answers. If there’s a question I’ve missed that you would like answered, or if you have an answer to a question that I failed to answer adequately, contact me through my Web site: www.ericmarcus.com.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And remember, there really is no such thing as a stupid question—except for the question you don’t ask.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  })]), _c('a', {
    attrs: {
      "id": "page14"
    }
  })]), _c('a', {
    attrs: {
      "id": "page14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a8677ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780061745287_frontmatterpage_02.vue
// module id = 72
// module chunks = 0